/* unplugin-vue-components disabled */import script from "./WOOrganizationList.vue?vue&type=script&setup=true&lang=js"
export * from "./WOOrganizationList.vue?vue&type=script&setup=true&lang=js"

import "./WOOrganizationList.vue?vue&type=style&index=0&id=0c7fb73d&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c7fb73d"]])

export default __exports__